import { render } from "./IssuerWizard.vue?vue&type=template&id=4f136910"
import script from "./IssuerWizard.vue?vue&type=script&lang=js"
export * from "./IssuerWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__